import {axios} from '../../../lib'

export const getCompanySettings = () => {
    return axios.get('/settings')
}
